export const getMonthYearDate =  (date)  => {
    if (date === null || date === undefined ){
      return new Date()
    }
    let dateSplited = date.split("T")[0].split("-")
    let dateMonthYear = new Date(dateSplited[0],dateSplited[1]-1,1)
    return dateMonthYear
  }